<!-- Courses Section -->
<section
  class="py-24 bg-white border-t border-slate-200/60"
  aria-labelledby="courses-heading"
>
  <div class="container mx-auto px-6">
    <!-- Section Header -->
    <div class="text-center max-w-3xl mx-auto mb-16 space-y-4">
      <div
        class="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider"
      >
        <i class="fa-solid fa-graduation-cap"></i>
        <span>Academic Streams</span>
      </div>
      <h2
        id="courses-heading"
        class="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight"
      >
        Comprehensive Learning Paths
      </h2>
      <p class="text-lg text-slate-600 leading-relaxed">
        Tailored educational programs for local syllabus and international
        curriculum requirements.
      </p>
    </div>

    <!-- Courses Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
      <!-- A/L Preparation Card -->
      <div
        class="daisy-card bg-slate-50/80 border border-slate-200/80 hover:border-blue-300 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between"
      >
        <div class="daisy-card-body p-8 space-y-6">
          <div class="flex items-center justify-between">
            <span
              class="daisy-badge daisy-badge-primary px-3 py-2 text-xs font-bold rounded-lg flex items-center gap-1.5"
            >
              <i class="fa-solid fa-fire text-amber-300"></i> Advanced Level
            </span>
            <div
              class="w-12 h-12 rounded-2xl bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-xl"
            >
              <i class="fa-solid fa-book-bookmark"></i>
            </div>
          </div>

          <div>
            <h3 class="text-2xl font-bold text-slate-900 mb-2">
              G.C.E. A/L Stream
            </h3>
            <p class="text-slate-600 text-sm leading-relaxed">
              Comprehensive coverage of Science, Commerce, Arts, and Technology
              streams with exam-focused revision and past paper drills.
            </p>
          </div>

          <ul class="space-y-3 text-sm text-slate-700">
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Maths, Science, Commerce & Tech</span>
            </li>
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Paper discussion & Model test sessions</span>
            </li>
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Theory + Revision targeted modules</span>
            </li>
          </ul>
        </div>

        <div
          class="px-8 pb-8 pt-0 flex items-center justify-between border-t border-slate-200/60 mt-4"
        >
          <span
            class="daisy-badge daisy-badge-ghost border-slate-200 text-slate-600 text-xs px-3 py-2 flex items-center gap-1.5"
          >
            <span
              class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"
            ></span>
            Enrollment Open
          </span>
          <a
            routerLink="/live-classes"
            class="daisy-btn daisy-btn-sm daisy-btn-primary bg-blue-600 hover:bg-blue-500 border-none text-white rounded-xl gap-1.5"
          >
            <span>View Classes</span>
            <i class="fa-solid fa-arrow-right text-xs"></i>
          </a>
        </div>
      </div>

      <!-- O/L Local Syllabus Card -->
      <div
        class="daisy-card bg-slate-50/80 border border-slate-200/80 hover:border-purple-300 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between"
      >
        <div class="daisy-card-body p-8 space-y-6">
          <div class="flex items-center justify-between">
            <span
              class="daisy-badge daisy-badge-secondary px-3 py-2 text-xs font-bold rounded-lg flex items-center gap-1.5"
            >
              <i class="fa-solid fa-star text-amber-300"></i> Ordinary Level
            </span>
            <div
              class="w-12 h-12 rounded-2xl bg-purple-100 text-purple-600 flex items-center justify-center font-bold text-xl"
            >
              <i class="fa-solid fa-file-pen"></i>
            </div>
          </div>

          <div>
            <h3 class="text-2xl font-bold text-slate-900 mb-2">
              G.C.E. O/L Local Syllabus
            </h3>
            <p class="text-slate-600 text-sm leading-relaxed">
              Structured foundation and final-year masterclasses covering
              Mathematics, Science, English, Sinhala, and core electives.
            </p>
          </div>

          <ul class="space-y-3 text-sm text-slate-700">
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Complete 9-subject coverage</span>
            </li>
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Term test paper preparation</span>
            </li>
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Grades 6 to 11 syllabus modules</span>
            </li>
          </ul>
        </div>

        <div
          class="px-8 pb-8 pt-0 flex items-center justify-between border-t border-slate-200/60 mt-4"
        >
          <span
            class="daisy-badge daisy-badge-ghost border-slate-200 text-slate-600 text-xs px-3 py-2 flex items-center gap-1.5"
          >
            <span
              class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"
            ></span>
            Enrollment Open
          </span>
          <a
            routerLink="/live-classes"
            class="daisy-btn daisy-btn-sm daisy-btn-secondary bg-purple-600 hover:bg-purple-500 border-none text-white rounded-xl gap-1.5"
          >
            <span>View Classes</span>
            <i class="fa-solid fa-arrow-right text-xs"></i>
          </a>
        </div>
      </div>

      <!-- O/L Edexcel Card -->
      <div
        class="daisy-card bg-slate-50/80 border border-slate-200/80 hover:border-cyan-300 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between"
      >
        <div class="daisy-card-body p-8 space-y-6">
          <div class="flex items-center justify-between">
            <span
              class="daisy-badge daisy-badge-accent px-3 py-2 text-xs font-bold rounded-lg flex items-center gap-1.5 text-slate-900"
            >
              <i class="fa-solid fa-globe"></i> International
            </span>
            <div
              class="w-12 h-12 rounded-2xl bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-xl"
            >
              <i class="fa-solid fa-earth-americas"></i>
            </div>
          </div>

          <div>
            <h3 class="text-2xl font-bold text-slate-900 mb-2">
              Edexcel & Cambridge
            </h3>
            <p class="text-slate-600 text-sm leading-relaxed">
              International GCSE and IAL preparation focused on global board
              standards, past paper solving, and university entry preparation.
            </p>
          </div>

          <ul class="space-y-3 text-sm text-slate-700">
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Edexcel & Cambridge curricula</span>
            </li>
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>Topic-by-topic past paper practice</span>
            </li>
            <li class="flex items-center gap-2.5">
              <i class="fa-solid fa-circle-check text-emerald-500"></i>
              <span>International grade benchmarked</span>
            </li>
          </ul>
        </div>

        <div
          class="px-8 pb-8 pt-0 flex items-center justify-between border-t border-slate-200/60 mt-4"
        >
          <span
            class="daisy-badge daisy-badge-ghost border-slate-200 text-slate-600 text-xs px-3 py-2 flex items-center gap-1.5"
          >
            <span
              class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"
            ></span>
            Enrollment Open
          </span>
          <a
            routerLink="/live-classes"
            class="daisy-btn daisy-btn-sm daisy-btn-accent bg-cyan-500 hover:bg-cyan-400 border-none text-slate-950 font-bold rounded-xl gap-1.5"
          >
            <span>View Classes</span>
            <i class="fa-solid fa-arrow-right text-xs"></i>
          </a>
        </div>
      </div>
    </div>

    <!-- Banner CTA Box -->
    <div
      class="daisy-card bg-gradient-to-r from-blue-50 via-slate-50 to-indigo-50 border border-slate-200/80 p-8 sm:p-12 rounded-3xl text-center max-w-4xl mx-auto shadow-sm"
    >
      <div class="space-y-4">
        <h3 class="text-2xl sm:text-3xl font-extrabold text-slate-900">
          Ready to Start Learning?
        </h3>
        <p class="text-slate-600 text-base sm:text-lg max-w-2xl mx-auto">
          Create your account today to join live classes, access study
          resources, and get ahead in your academic journey.
        </p>
        <div
          class="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            routerLink="/auth/register"
            class="daisy-btn daisy-btn-primary bg-blue-600 hover:bg-blue-500 text-white border-none px-8 rounded-xl shadow-md flex items-center gap-2"
          >
            <i class="fa-solid fa-user-plus"></i>
            <span>Register Now</span>
          </a>
          <a
            routerLink="/live-classes"
            class="daisy-btn daisy-btn-outline border-slate-300 text-slate-700 hover:bg-slate-100 px-8 rounded-xl flex items-center gap-2"
          >
            <i class="fa-solid fa-compass"></i>
            <span>Browse Catalog</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
